const JOURNEY_BASE_PATHS = {
  WATER_METER_ORDER: '/inbetriebnahme/wasser',
  ELECTRIC_METER_ORDER: '/inbetriebnahme/strom',
  GAS_METER_ORDER: '/inbetriebnahme/gas',
  SITE_ELECTRIC_METER_ORDER: '/inbetriebnahme/baustrom',
  EVENT_ELECTRIC_METER_ORDER: '/inbetriebnahme/veranstaltungsstrom',
};

const WATER_JOURNEY_EDIT_TARGETS = {
  'connection-address': { step: 1, substep: 1 },
  'meter-position': { step: 1, substep: 2 },
  unit: { step: 1, substep: 3 },
  'measure-type': { step: 2, substep: 1 },
  'measure-reason': { step: 2, substep: 2 },
  'additional-meter-installation': { step: 2, substep: 2 },
  'business-type': { step: 3, substep: 1 },
  'usage-type': { step: 3, substep: 1 },
  'counter-data': { step: 3, substep: 1 },
  'personal-data': { step: 4, substep: 1 },
  'customer-business-type': { step: 4, substep: 1 },
  'customer-address': { step: 4, substep: 2 },
  'contact-details': { step: 4, substep: 3 },
  'application-remarks': { step: 5, substep: 2 },
};

const ELECTRICITY_JOURNEY_EDIT_TARGETS = {
  'connection-address': { step: 1, substep: 1 },
  'meter-position': { step: 1, substep: 2 },
  unit: { step: 1, substep: 3 },
  'measure-type': { step: 2, substep: 1 },
  'measure-reason': { step: 2, substep: 2 },
  'meter-type': { step: 2, substep: 2 },
  'additional-meter-installation': { step: 2, substep: 2 },
  'meter-bidirectional': { step: 2, substep: 2 },
  'business-type': { step: 3, substep: 1 },
  'usage-type': { step: 3, substep: 1 },
  'counter-data': { step: 3, substep: 1 },
  'power-appliances': { step: 3, substep: 2 },
  'technical-electric-data': { step: 3, substep: 2 },
  feedin: { step: 3, substep: 2 },
  'personal-data': { step: 4, substep: 1 },
  'customer-business-type': { step: 4, substep: 1 },
  'customer-address': { step: 4, substep: 2 },
  'contact-details': { step: 4, substep: 3 },
  'application-remarks': { step: 5, substep: 2 },
};

const GAS_JOURNEY_EDIT_TARGETS = {
  'connection-address': { step: 1, substep: 1 },
  'meter-position': { step: 1, substep: 2 },
  unit: { step: 1, substep: 3 },
  'measure-type': { step: 2, substep: 1 },
  'measure-reason': { step: 2, substep: 2 },
  'additional-meter-installation': { step: 2, substep: 2 },
  'business-type': { step: 3, substep: 1 },
  'usage-type': { step: 3, substep: 1 },
  'meter-size': { step: 3, substep: 2 },
  'gas-appliances': { step: 3, substep: 2 },
  'counter-data': { step: 3, substep: 1 },
  'personal-data': { step: 4, substep: 1 },
  'customer-business-type': { step: 4, substep: 1 },
  'customer-address': { step: 4, substep: 2 },
  'contact-details': { step: 4, substep: 3 },
  'application-remarks': { step: 5, substep: 2 },
};

const SITE_ELECTRICITY_JOURNEY_EDIT_TARGETS = {
  'connection-address': { step: 1, substep: 1 },
  'meter-position': { step: 1, substep: 2 },
  'measure-type': { step: 2, substep: 1 },
  'additional-meter-installation': { step: 2, substep: 2 },
  'technical-electric-data': { step: 3, substep: 1 },
  'counter-data': { step: 3, substep: 1 },
  'personal-data': { step: 4, substep: 1 },
  'customer-business-type': { step: 4, substep: 1 },
  'customer-address': { step: 4, substep: 2 },
  'alternate-invoice-recipient': { step: 4, substep: 2 },
  'contact-details': { step: 4, substep: 3 },
  'application-remarks': { step: 5, substep: 2 },
};

const EVENT_ELECTRICITY_JOURNEY_EDIT_TARGETS = {
  'connection-address': { step: 1, substep: 1 },
  'meter-position': { step: 1, substep: 2 },
  'measure-type': { step: 2, substep: 1 },
  'event-dates': { step: 2, substep: 2 },
  'event-power-data': { step: 3, substep: 1 },
  'counter-data': { step: 3, substep: 1 },
  'personal-data': { step: 4, substep: 1 },
  'customer-business-type': { step: 4, substep: 1 },
  'customer-address': { step: 4, substep: 2 },
  'alternate-invoice-recipient': { step: 4, substep: 2 },
  'contact-details': { step: 4, substep: 3 },
};

const JOURNEY_EDIT_TARGETS = {
  WATER_METER_ORDER: WATER_JOURNEY_EDIT_TARGETS,
  ELECTRIC_METER_ORDER: ELECTRICITY_JOURNEY_EDIT_TARGETS,
  GAS_METER_ORDER: GAS_JOURNEY_EDIT_TARGETS,
  SITE_ELECTRIC_METER_ORDER: SITE_ELECTRICITY_JOURNEY_EDIT_TARGETS,
  EVENT_ELECTRIC_METER_ORDER: EVENT_ELECTRICITY_JOURNEY_EDIT_TARGETS,
};

// Zählerwechsel WAÄ skips the usage substep for Gas/Strom and ends step 3 with the counter data.
const SYSTEM_CHANGE_EDIT_TARGETS = {
  WATER_METER_ORDER: {
    'counter-data': { step: 3, substep: 2 },
  },
  ELECTRIC_METER_ORDER: {
    'power-appliances': { step: 3, substep: 1 },
    'technical-electric-data': { step: 3, substep: 1 },
    feedin: { step: 3, substep: 1 },
    'counter-data': { step: 3, substep: 2 },
  },
  GAS_METER_ORDER: {
    'gas-appliances': { step: 3, substep: 1 },
    'meter-size': { step: 3, substep: 1 },
    'counter-data': { step: 3, substep: 2 },
  },
};

export function getSystemChangeEditTarget(journeyType, rowKey) {
  const journeyKey =
    typeof journeyType === 'string' ? journeyType.trim().toUpperCase() : '';

  return SYSTEM_CHANGE_EDIT_TARGETS[journeyKey]?.[rowKey] || null;
}

export function getInstallateurTrBaseUrl(stage = process.env.VUE_APP_STAGE) {
  if (stage === 'prod') {
    return 'https://installateur-tr-backoffice.new-netzportal.de';
  }

  return `https://${
    stage || 'dev'
  }.installateur-tr-backoffice.new-netzportal.de`;
}

export function buildJourneyEditUrl(
  journeyType,
  rowKey,
  orderId,
  targetOverride = null
) {
  const journeyKey =
    typeof journeyType === 'string' ? journeyType.trim().toUpperCase() : '';
  const journeyBasePath = JOURNEY_BASE_PATHS[journeyKey];
  const target = targetOverride || JOURNEY_EDIT_TARGETS[journeyKey]?.[rowKey];

  if (!journeyBasePath || !target || !orderId) {
    return null;
  }

  const path =
    target.step === 1 ? journeyBasePath : `${journeyBasePath}/${target.step}`;
  const url = new URL(`${getInstallateurTrBaseUrl()}${path}`);

  url.searchParams.set('process', orderId);
  url.searchParams.set('substep', String(target.substep));

  return url.toString();
}
